import { useApi, API_ENDPOINTS, transformPascalToCamel } from "@/lib/api"

/**
 * One AtsVendorConfiguration document as listed by Phoenix. `data` is the full
 * document body (the processor owns its shape); the binding fields are extracted
 * server-side for the list view.
 */
export interface AtsVendorConfigurationInfo {
  id: string | null
  atsSource: string | null
  atsSourceId: string | null
  atsSourceName: string | null
  lastModifiedDateTime: string
  data: Record<string, unknown>
}

export function useEventSync() {
  const { mainApi } = useApi()

  const loadConfigurations = async (): Promise<AtsVendorConfigurationInfo[]> => {
    const response = await mainApi.get<any[]>(API_ENDPOINTS.MAIN.ATS_VENDOR_CONFIGURATIONS)
    // Only the wrapper is normalized — `data` is the verbatim document body and its
    // property casing must round-trip untouched
    return (response ?? []).map((item: any) => {
      const wrapper = transformPascalToCamel({ ...item, Data: undefined, data: undefined }) as any
      return { ...wrapper, data: item.Data ?? item.data ?? {} } as AtsVendorConfigurationInfo
    })
  }

  const saveConfiguration = async (
    id: string | null,
    data: Record<string, unknown>
  ): Promise<AtsVendorConfigurationInfo> => {
    const response = await mainApi.post<any>(API_ENDPOINTS.MAIN.ATS_VENDOR_CONFIGURATIONS, { id, data })
    const wrapper = transformPascalToCamel({ ...response, Data: undefined, data: undefined }) as any
    return { ...wrapper, data: response.Data ?? response.data ?? {} } as AtsVendorConfigurationInfo
  }

  const deleteConfiguration = async (id: string): Promise<void> => {
    await mainApi.delete(API_ENDPOINTS.MAIN.ATS_VENDOR_CONFIGURATION(id))
  }

  return { loadConfigurations, saveConfiguration, deleteConfiguration }
}
